/**
 * 📦 재고 · 📅 일정 두 칸 전환 — 홈 화면 앱(`/m/*`) 안에서만 쓴다 (v2.188.0 · 2026-09-17).
 *
 * ⭐⭐⭐**왜 「앱 하나에 두 칸」인가.** 안드로이드 크롬은 **한 주소(origin)에 앱을 하나만**
 *   깔게 한다. 이미 깔린 앱의 **범위가 이 주소를 덮으면** 「이미 설치됨」으로 보고 설치 신호
 *   (`beforeinstallprompt`)를 **아예 던지지 않는다**(구글 문서가 그렇게 적고 있고, 2026-09-17 에
 *   실제로 그렇게 막혔다 — 「SM 포털」 앱의 범위가 `/` 라 `/m/calendar` 를 덮는다).
 *   범위를 좁혀 앱을 둘로 만들 수도 있지만, 그러면 `/login`·2단계 인증·마이페이지가 **범위 밖**이
 *   되어 앱이 브라우저 탭으로 튕긴다(우리 로그인 쿠키는 **브라우저를 닫으면 만료**돼서 자주 겪는다).
 *   → **앱은 하나로 두고, 그 안에서 화면을 바꾼다.** 사용자 결정(2026-09-17).
 *
 * ⚠**아래쪽 탭 줄이 아니라 위쪽인 이유**: 재고 화면에는 `fixed bottom-0` 액션 바(출고등록·검수)가
 *   이미 있어서 아래에 두면 겹친다.
 * ⚠재고 화면은 **자기 헤더 안**에 이 줄을 넣고(그 화면은 페이지 전체가 스크롤된다),
 *   일정 화면은 **`MobileShell` 이 위에 고정 줄**로 얹는다(그 화면은 스크롤 상자 안에 있다).
 *   그래서 두 화면에서 줄의 자리가 같아 보인다.
 */

import { Link, useLocation } from 'react-router-dom';

const TABS = [
  { to: '/m/inventory', label: '📦 재고' },
  { to: '/m/calendar', label: '📅 일정' },
] as const;

export function MobileAppTabs() {
  const { pathname } = useLocation();
  return (
    <nav className="flex items-center gap-1" aria-label="앱 화면 전환">
      {TABS.map((t) => {
        const active = pathname.startsWith(t.to);
        return (
          <Link
            key={t.to}
            to={t.to}
            aria-current={active ? 'page' : undefined}
            className={
              active
                ? 'px-2.5 py-1 rounded bg-white/20 text-white text-sm font-bold whitespace-nowrap'
                : 'px-2.5 py-1 rounded text-slate-300 text-sm whitespace-nowrap active:bg-white/10'
            }
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
